
















import { defineComponent, PropType } from '@vue/composition-api';
import WeeklyChallengeBaseForm from './WeeklyChallangeBaseForm.vue';
import { useWeeklyChallenge } from '@/bundles/ActivityGroup/composables/useWeeklyChallenge';

export default defineComponent({
  name: 'WeeklyChallengeEditForm',

  components: {
    WeeklyChallengeBaseForm,
  },

  props: {
    challenge: {
      type: Object as PropType<any>,
      required: true,
    },
  },

  emits: ['list:refresh', 'close'],

  setup(props, {emit}) {
    const { updateWeeklyChallenge, loading } = useWeeklyChallenge();

    async function submitEventHandler(payload: any) {
      await updateWeeklyChallenge(props.challenge.id, payload);
      emit('list:refresh');
    }

    return {
      submitEventHandler,
      loading,
    };
  },
});
